"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class LvToAllianzUKTransferBannerWording {
}
exports.default = LvToAllianzUKTransferBannerWording;
//# sourceMappingURL=LvToAllianzUKTransferBannerWording.js.map